import { Controller } from "@hotwired/stimulus"
import $ from 'jquery';


export default class extends Controller {
  static targets = [ "customSelect" ]

  connect() {
  }

  customSelectTargetConnected(element) {
    const selectMultiple = element.dataset.selectMultiple 
    const labelPreview = element.querySelector('.preview-label')
    const previewInput = element.querySelector('.preview-input')
    const hiddenField = element.querySelector('.custom-select-hidden-field')
    $('.select-item', element).on('click', (event) => {
      const customSelectContainer = event.currentTarget
      let selectedLabels = [customSelectContainer.dataset.label]
      let selectedValues = [customSelectContainer.dataset.value]
      const checkboxControl = customSelectContainer.querySelector('input[type=checkbox]')

      if (selectMultiple && checkboxControl){
        if (event.target.type !== 'checkbox') {
          event.preventDefault()
          checkboxControl.checked = event.target.type === 'checkbox' ? checkboxControl.checked : !checkboxControl.checked;
        }
        const selectedItems = element.querySelectorAll('input[type=checkbox]:checked');

        selectedValues = Array.from(selectedItems).map(cb => 
          cb.closest('li').dataset.value
        );
        
        selectedLabels = Array.from(selectedItems).map(cb => 
          cb.closest('li').dataset.label
        );
        
      }

      if (hiddenField) hiddenField.value = selectedValues
      const displayValue = selectedLabels.length > 0 ? selectedLabels.join(', ') : "Select Item";
      if (labelPreview) labelPreview.innerHTML = displayValue
      if (previewInput) previewInput.value = displayValue

    })
  }

}